import { forwardRef } from "react";
import { StepProps, StepRef } from "../../types";
import OpenTextStep from "../../components/OpenTextStep";
import useIsMobile from "components/hooks/useIsMobile";

export default forwardRef<StepRef, StepProps>(
  ({ onNext, signupState }, _ref) => {
    const isMobile = useIsMobile();

    return (
      <OpenTextStep
        title={"Let's find your perfect match"}
        subtitle={
          "The more details you share, the better we are at finding the ideal Advisor for your family."
        }
        placeholder={
          isMobile
            ? "ex. Occupations, children, pets"
            : "ex. I'm a marketer at Google, and my spouse is a lawyer who works remotely. We have two daughters, 3 and 7 years old. We have a golden retriever and a cat."
        }
        label={"Start off by telling us about your family"}
        skippable={true}
        onNext={async (inputText) => {
          await onNext?.({ familyInfo: inputText });
        }}
        initialText={signupState?.familyInfo}
      />
    );
  },
);
